import { BonusByProductCardsTranslations } from ".";

export const BONUS_BY_PRODUCT_CARDS_EN_US: BonusByProductCardsTranslations = {
	totalProductsValue: "Total bonus in Products",
	totalTipValue: "Total bonus in Tip",
	totalValue: "Total",
	receivedInPeriod: "Received in the event",
	receivedAtAnotherPeriod: "Received in other events",
};
